/* Fichier: assets/ingredients-interactifs.js */

// Fonction principale d'initialisation (nommée pour être rappelée)
function initInteractiveIngredients(sectionContainer) {
  if (!sectionContainer) return;

  // --- B. ÉLÉMENTS DOM ---
  const triggers = sectionContainer.querySelectorAll('.ii-trigger');
  const panel = sectionContainer.querySelector('.ii-panel');

  // Éléments internes de la popup
  const panelImg = sectionContainer.querySelector('.ii-panel-img');
  const panelTitle = sectionContainer.querySelector('.ii-title');
  const panelDescHtml = sectionContainer.querySelector('.ii-desc-html');

  if (!panel) return;

  // --- A. GESTION DE L'AFFICHAGE (Fix écran blanc) ---
  // Si on est dans l'éditeur Shopify, on affiche tout de suite
  if (window.Shopify && window.Shopify.designMode) {
    sectionContainer.classList.add('is-visible');
  } else {
    // Sinon (visiteur normal), on utilise le Lazy Load au scroll
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
            // Précharge les images 1000px en arrière-plan dès que la section est visible
            triggers.forEach(function(t) {
              const src = t.getAttribute('data-img');
              if (src) { const img = new Image(); img.src = src; }
            });
          }
        });
      }, { threshold: 0.2 });
      observer.observe(sectionContainer);
    } else {
      sectionContainer.classList.add('is-visible');
      triggers.forEach(function(t) {
        const src = t.getAttribute('data-img');
        if (src) { const img = new Image(); img.src = src; }
      });
    }
  }

  // Fonction pour fermer la popup
  function closePopup() {
    panel.classList.remove('is-open');
  }

  // --- C. GESTION DES CLICS ---

  // 1. Ouvrir la popup au clic sur un ingrédient
  triggers.forEach(trigger => {
    trigger.addEventListener('click', function(e) {
      e.stopPropagation(); // Empêche la fermeture immédiate

      // Récupérer les données
      const imgUrl = this.getAttribute('data-img');
      const title = this.getAttribute('data-title');
      const index = this.getAttribute('data-index');
      
      // Récupérer le HTML caché (Rich Text)
      const sectionId = sectionContainer.getAttribute('data-id');
      const hiddenContentId = `ii-content-${sectionId}-${index}`;
      const hiddenContent = document.getElementById(hiddenContentId);

      // Injecter texte
      if(panelTitle) panelTitle.textContent = title;
      if(panelDescHtml && hiddenContent) {
        panelDescHtml.innerHTML = hiddenContent.innerHTML;
      }

      // Injecter image avec fondu (évite le flash de l'ancienne image)
      if(panelImg) {
        panelImg.style.opacity = '0';
        const tmpImg = new Image();
        tmpImg.onload = function() {
          panelImg.src = imgUrl;
          panelImg.style.opacity = '1';
        };
        tmpImg.src = imgUrl;
      }

      // Ouvrir
      panel.classList.add('is-open');
    });
  });

  // 2. Fermer la popup (Clic n'importe où sur le panel)
  // Le panel couvre tout l'écran, donc un clic dessus = fermeture
  panel.addEventListener('click', function() {
    closePopup();
  });
}

// --- INITIALISATION ---

// 1. Au chargement initial de la page
document.addEventListener("DOMContentLoaded", function() {
  const sections = document.querySelectorAll('.ii-section');
  sections.forEach(section => initInteractiveIngredients(section));
});

// 2. Écouteur d'événement SPÉCIFIQUE SHOPIFY (Pour l'éditeur)
// Se déclenche quand on modifie une section et que Shopify recharge le HTML
document.addEventListener('shopify:section:load', function(event) {
  const section = event.target.querySelector('.ii-section');
  if (section) {
    initInteractiveIngredients(section);
  }
});